console.log('hello worlds.');

function setFullscreenHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  setFullscreenHeight();
  
  let currentOrientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  
  window.addEventListener('resize', () => {
    const newOrientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  
    if (newOrientation !== currentOrientation) {
      currentOrientation = newOrientation;
      setFullscreenHeight();
    }
  });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.dn-burger').addEventListener('click', function () {
    const body = document.body;

    if (!body.classList.contains('dn-mobile-menu-active')) {
      body.classList.add('dn-mobile-menu-active');
      body.classList.remove('dn-mobile-menu-inactive');
    } else {
      body.classList.remove('dn-mobile-menu-active');
      body.classList.add('dn-mobile-menu-inactive');
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 992) {
      document.body.classList.remove('dn-mobile-menu-active');
    }
  });

  const header = document.querySelector('.dn-header');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 30) {
      header.classList.add('dn-header-scrolled');
    } else {
      header.classList.remove('dn-header-scrolled');
    }
  });
});

// Accordion
document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('.dn-accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.dn-accordion-item');
      const content = item.querySelector('.dn-accordion-content');

      if (item.classList.contains('active')) {
        // Schließen
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0';
          content.style.opacity = 0;
        });
        item.classList.remove('active');
      } else {
        // Öffnen
        item.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
        content.style.opacity = 1;

        content.addEventListener('transitionend', function handler() {
          content.style.height = 'auto'; // Danach flexibel
          content.removeEventListener('transitionend', handler);
        });
      }
    });
  });
});

// Formular
document.querySelectorAll('.dn-custom-file input[type="file"]').forEach(input => {
  input.addEventListener('change', e => {
    const fileName = input.files[0] ? input.files[0].name : 'Keine Datei';
    input.closest('.dn-custom-file').querySelector('.dn-filename').textContent = fileName;
  });
});

flatpickr(".dn-datepicker", {
  dateFormat: "Y-m-d", // Format: 2025-07-30
  altInput: true,
  altFormat: "d.m.Y",   // Format für den Nutzer: 30.07.2025
  allowInput: true
});

flatpickr(".dn-timepicker", {
  enableTime: true,
  noCalendar: true,
  dateFormat: "H:i",
  time_24hr: true
});

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  gsap.to('.dn-image-parallax', {
    y: -100,
    ease: "none",
    scrollTrigger: {
      trigger: '.dn-image-parallax',
      start: 'top bottom',
      scrub: true
    }
  });
});

gsap.registerPlugin(ScrollTrigger);

// Beispiel: Alle Blöcke mit Klasse .dn-section sollen smooth einblenden
gsap.utils.toArray('.dn-animate').forEach(section => {
  gsap.from(section, {
    opacity: 0,
    y: 20,  // leicht nach unten versetzt starten
    duration: 1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: section,
      start: "top 80%",  // Animation starten wenn Sektion zu 80% im Viewport ist
      toggleActions: "play none none none",
      // optional: einmal abspielen, kein Zurücksetzen
    }
  });
});

// Beispiel: Alle Blöcke mit Klasse .dn-section sollen smooth einblenden
gsap.utils.toArray('.dn-block').forEach(section => {
  gsap.from(section, {
    opacity: 0,
    y: 20,  // leicht nach unten versetzt starten
    duration: 1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: section,
      start: "top 80%",  // Animation starten wenn Sektion zu 80% im Viewport ist
      toggleActions: "play none none none",
      // optional: einmal abspielen, kein Zurücksetzen
    }
  });
});

Fancybox.bind("[data-fancybox]", {
  // Your custom options
});